// First API Layer of claim module
import { general } from './general'
import { claim } from './claim'
import { clmRIRcvy } from './clmRIRcvy'

export const actions = Object.assign({}, general, claim, clmRIRcvy)
